import { useTranslation } from 'react-i18next';
import { dateFormat, numberToCurrency } from 'utils/translate';

export default function DrawerOffer({
  amount,
  mtp,
  dueDate,
}: {
  amount?: number;
  mtp?: number;
  dueDate?: string;
}) {
  const { t } = useTranslation('calculator');
  return (
    <div className="flex flex-col">
      <div className="flex justify-between py-3 border-b items-baseline">
        <div className="font-bold text-xs">{t('offer.mtp')}</div>
        {mtp ? (
          <div
            className="font-bold text-lg"
            data-test="drawer-offer-monthly-payment"
          >
            {numberToCurrency(mtp)}
          </div>
        ) : (
          <div className="animate-pulse bg-background-accent h-6 w-24" />
        )}
      </div>

      <div className="flex justify-between py-3 border-t border-b items-baseline">
        <div>{t('offer.loan')}</div>
        {amount ? (
          <div data-test="drawer-offer-amount">{numberToCurrency(amount)}</div>
        ) : (
          <div className="animate-pulse bg-background-accent h-6 w-24" />
        )}
      </div>

      <div className="flex justify-between py-3 border-t border-b items-baseline">
        <div>{t('offer.due_date')}</div>
        {dueDate ? (
          <div data-test="due-date">{dateFormat(dueDate)}</div>
        ) : (
          <div className="animate-pulse bg-background-accent h-6 w-24" />
        )}
      </div>
    </div>
  );
}
